import styled from "styled-components";
import { Dropdown } from "capitalrx-components-2.0/lib/forms";

export const ThemedDropdown = Object.assign(
  styled(Dropdown)`
    .control,
    .control:focus,
    .control:focus-visible,
    .value-container:focus,
    .value-container:focus-visible {
      border: none !important;
      padding: 0 !important;
      box-shadow: none !important;

      .arrow > .icon-container path {
        fill: #313e48 !important;
      }
    }

    /* Label text styling */
    label > div.inline > span.semibold {
      font:
        400 14px "Source Sans Pro",
        sans-serif !important;
    }

    /* Selected value styling */
    .single-value {
      font-weight: 600;
      color: #313e48;
      font-size: 20px;
    }
  `,
  {
    Option: Dropdown.Option,
  },
);
